/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { PaginatedSellerPriceGridListingList } from '../model';
// @ts-ignore
import { SellerPriceGridListing } from '../model';
// @ts-ignore
import { SellerPriceGridSearchOrderingRequest } from '../model';
// @ts-ignore
import { SellerPriceGridSearchRequest } from '../model';
/**
 * SellerPriceGridsSearchApi - axios parameter creator
 * @export
 */
export const SellerPriceGridsSearchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a list of all the status=ACTIVE Price Grids which match the given search criteria  It is also filtered on the visibility of the grid.If it is is PUBLIC then everyone can see it.If it is CONTACTS only then only those who are approved contacts of the Buyer organisation can see it.  ## Filters See parameters below  ## Ordering The following fields can be used for ordering, it can be done by passing in the ordering query string param. eg. `?ordering=updated` To reverse, simply place a hyphen in front. eg. `?ordering=-updated`  - updated: The last time the grid was updated (default: -updated = latest to oldest) - name: The buyer organisations name - price: The pricing range, default is highest first so it goes against the price_range_max field, when     -price then it goes via the min field     -When searching via this then those that are set to PRICE_RANGE will be at the top of the listing, even in both     -orders `price` and `-price`. Putting those that are POA and MARKET_RATE at the bottom.  The results by default are returned with the latest updated first.         
         * @summary Perform a search on the accessible price grids.
         * @param {SellerPriceGridSearchRequest} sellerPriceGridSearchRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {Array<'-delivery_date' | '-name' | '-price' | '-updated' | 'delivery_date' | 'name' | 'price' | 'updated'>} [ordering] Ordering  * &#x60;updated&#x60; - Updated * &#x60;-updated&#x60; - Updated (descending) * &#x60;name&#x60; - Name * &#x60;-name&#x60; - Name (descending) * &#x60;price&#x60; - Price * &#x60;-price&#x60; - Price (descending) * &#x60;delivery_date&#x60; - Delivery date * &#x60;-delivery_date&#x60; - Delivery date (descending)
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerGridCreate: async (sellerPriceGridSearchRequest: SellerPriceGridSearchRequest, aaSource?: string, ordering?: Array<'-delivery_date' | '-name' | '-price' | '-updated' | 'delivery_date' | 'name' | 'price' | 'updated'>, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sellerPriceGridSearchRequest' is not null or undefined
            assertParamExists('sellerGridCreate', 'sellerPriceGridSearchRequest', sellerPriceGridSearchRequest)
            const localVarPath = `/v2/seller/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }

            if (ordering) {
                localVarQueryParameter['ordering'] = ordering.join(COLLECTION_FORMATS.csv);
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sellerPriceGridSearchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Get the details of a price grid
         * @param {string} priceGridId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerGridRetrieve: async (priceGridId: string, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'priceGridId' is not null or undefined
            assertParamExists('sellerGridRetrieve', 'priceGridId', priceGridId)
            const localVarPath = `/v2/seller/grid/{price_grid_id}`
                .replace(`{${"price_grid_id"}}`, encodeURIComponent(String(priceGridId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of all the status=ACTIVE Price Grids which match the given search criteria  It is also filtered on the visibility of the grid.If it is is PUBLIC then everyone can see it.If it is CONTACTS only then only those who are approved contacts of the Buyer organisation can see it.  ## Filters See parameters below  ## Ordering The following fields can be used for ordering, it can be done by passing in the ordering query string param. eg. `?ordering=updated` To reverse, simply place a hyphen in front. eg. `?ordering=-updated`  - updated: The last time the grid was updated (default: -updated = latest to oldest) - name: The buyer organisations name - price: The pricing range, default is highest first so it goes against the price_range_max field, when     -price then it goes via the min field     -When searching via this then those that are set to PRICE_RANGE will be at the top of the listing, even in both     -orders `price` and `-price`. Putting those that are POA and MARKET_RATE at the bottom.  The results by default are returned with the latest updated first.         
         * @summary Perform a search on the accessible price grids.
         * @param {SellerPriceGridSearchRequest} sellerPriceGridSearchRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {Array<'-delivery_date' | '-name' | '-price' | '-updated' | 'delivery_date' | 'name' | 'price' | 'updated'>} [ordering] Ordering  * &#x60;updated&#x60; - Updated * &#x60;-updated&#x60; - Updated (descending) * &#x60;name&#x60; - Name * &#x60;-name&#x60; - Name (descending) * &#x60;price&#x60; - Price * &#x60;-price&#x60; - Price (descending) * &#x60;delivery_date&#x60; - Delivery date * &#x60;-delivery_date&#x60; - Delivery date (descending)
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerGridSearchCreate: async (sellerPriceGridSearchRequest: SellerPriceGridSearchRequest, aaSource?: string, ordering?: Array<'-delivery_date' | '-name' | '-price' | '-updated' | 'delivery_date' | 'name' | 'price' | 'updated'>, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sellerPriceGridSearchRequest' is not null or undefined
            assertParamExists('sellerGridSearchCreate', 'sellerPriceGridSearchRequest', sellerPriceGridSearchRequest)
            const localVarPath = `/v2/seller/grid/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }

            if (ordering) {
                localVarQueryParameter['ordering'] = ordering.join(COLLECTION_FORMATS.csv);
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sellerPriceGridSearchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The view behaves in the same manner as the search listing but it returns only those who the user has bookmarked
         * @summary Returns the prices the user has bookmarked
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {Array<'-delivery_date' | '-name' | '-price' | '-updated' | 'delivery_date' | 'name' | 'price' | 'updated'>} [ordering] Ordering  * &#x60;updated&#x60; - Updated * &#x60;-updated&#x60; - Updated (descending) * &#x60;name&#x60; - Name * &#x60;-name&#x60; - Name (descending) * &#x60;price&#x60; - Price * &#x60;-price&#x60; - Price (descending) * &#x60;delivery_date&#x60; - Delivery date * &#x60;-delivery_date&#x60; - Delivery date (descending)
         * @param {number} [pageSize] Number of results to return per page.
         * @param {SellerPriceGridSearchOrderingRequest} [sellerPriceGridSearchOrderingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerGridSearchMyPricesCreate: async (aaSource?: string, ordering?: Array<'-delivery_date' | '-name' | '-price' | '-updated' | 'delivery_date' | 'name' | 'price' | 'updated'>, pageSize?: number, sellerPriceGridSearchOrderingRequest?: SellerPriceGridSearchOrderingRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/seller/grid/search/my-prices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }

            if (ordering) {
                localVarQueryParameter['ordering'] = ordering.join(COLLECTION_FORMATS.csv);
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sellerPriceGridSearchOrderingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Get the details of a price grid
         * @param {string} priceGridId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerGridSearchRetrieve: async (priceGridId: string, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'priceGridId' is not null or undefined
            assertParamExists('sellerGridSearchRetrieve', 'priceGridId', priceGridId)
            const localVarPath = `/v2/seller/grid/search/{price_grid_id}`
                .replace(`{${"price_grid_id"}}`, encodeURIComponent(String(priceGridId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Increments the view count on the Price Grid from the app
         * @param {string} priceGridId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerGridSearchViewPriceGridRetrieve: async (priceGridId: string, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'priceGridId' is not null or undefined
            assertParamExists('sellerGridSearchViewPriceGridRetrieve', 'priceGridId', priceGridId)
            const localVarPath = `/v2/seller/grid/search/{price_grid_id}/view-price-grid`
                .replace(`{${"price_grid_id"}}`, encodeURIComponent(String(priceGridId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Increments the view count on the Price Grid from the app
         * @param {string} priceGridId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerGridViewPriceGridRetrieve: async (priceGridId: string, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'priceGridId' is not null or undefined
            assertParamExists('sellerGridViewPriceGridRetrieve', 'priceGridId', priceGridId)
            const localVarPath = `/v2/seller/grid/{price_grid_id}/view-price-grid`
                .replace(`{${"price_grid_id"}}`, encodeURIComponent(String(priceGridId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SellerPriceGridsSearchApi - functional programming interface
 * @export
 */
export const SellerPriceGridsSearchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SellerPriceGridsSearchApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns a list of all the status=ACTIVE Price Grids which match the given search criteria  It is also filtered on the visibility of the grid.If it is is PUBLIC then everyone can see it.If it is CONTACTS only then only those who are approved contacts of the Buyer organisation can see it.  ## Filters See parameters below  ## Ordering The following fields can be used for ordering, it can be done by passing in the ordering query string param. eg. `?ordering=updated` To reverse, simply place a hyphen in front. eg. `?ordering=-updated`  - updated: The last time the grid was updated (default: -updated = latest to oldest) - name: The buyer organisations name - price: The pricing range, default is highest first so it goes against the price_range_max field, when     -price then it goes via the min field     -When searching via this then those that are set to PRICE_RANGE will be at the top of the listing, even in both     -orders `price` and `-price`. Putting those that are POA and MARKET_RATE at the bottom.  The results by default are returned with the latest updated first.         
         * @summary Perform a search on the accessible price grids.
         * @param {SellerPriceGridSearchRequest} sellerPriceGridSearchRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {Array<'-delivery_date' | '-name' | '-price' | '-updated' | 'delivery_date' | 'name' | 'price' | 'updated'>} [ordering] Ordering  * &#x60;updated&#x60; - Updated * &#x60;-updated&#x60; - Updated (descending) * &#x60;name&#x60; - Name * &#x60;-name&#x60; - Name (descending) * &#x60;price&#x60; - Price * &#x60;-price&#x60; - Price (descending) * &#x60;delivery_date&#x60; - Delivery date * &#x60;-delivery_date&#x60; - Delivery date (descending)
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sellerGridCreate(sellerPriceGridSearchRequest: SellerPriceGridSearchRequest, aaSource?: string, ordering?: Array<'-delivery_date' | '-name' | '-price' | '-updated' | 'delivery_date' | 'name' | 'price' | 'updated'>, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedSellerPriceGridListingList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sellerGridCreate(sellerPriceGridSearchRequest, aaSource, ordering, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Get the details of a price grid
         * @param {string} priceGridId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sellerGridRetrieve(priceGridId: string, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SellerPriceGridListing>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sellerGridRetrieve(priceGridId, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list of all the status=ACTIVE Price Grids which match the given search criteria  It is also filtered on the visibility of the grid.If it is is PUBLIC then everyone can see it.If it is CONTACTS only then only those who are approved contacts of the Buyer organisation can see it.  ## Filters See parameters below  ## Ordering The following fields can be used for ordering, it can be done by passing in the ordering query string param. eg. `?ordering=updated` To reverse, simply place a hyphen in front. eg. `?ordering=-updated`  - updated: The last time the grid was updated (default: -updated = latest to oldest) - name: The buyer organisations name - price: The pricing range, default is highest first so it goes against the price_range_max field, when     -price then it goes via the min field     -When searching via this then those that are set to PRICE_RANGE will be at the top of the listing, even in both     -orders `price` and `-price`. Putting those that are POA and MARKET_RATE at the bottom.  The results by default are returned with the latest updated first.         
         * @summary Perform a search on the accessible price grids.
         * @param {SellerPriceGridSearchRequest} sellerPriceGridSearchRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {Array<'-delivery_date' | '-name' | '-price' | '-updated' | 'delivery_date' | 'name' | 'price' | 'updated'>} [ordering] Ordering  * &#x60;updated&#x60; - Updated * &#x60;-updated&#x60; - Updated (descending) * &#x60;name&#x60; - Name * &#x60;-name&#x60; - Name (descending) * &#x60;price&#x60; - Price * &#x60;-price&#x60; - Price (descending) * &#x60;delivery_date&#x60; - Delivery date * &#x60;-delivery_date&#x60; - Delivery date (descending)
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sellerGridSearchCreate(sellerPriceGridSearchRequest: SellerPriceGridSearchRequest, aaSource?: string, ordering?: Array<'-delivery_date' | '-name' | '-price' | '-updated' | 'delivery_date' | 'name' | 'price' | 'updated'>, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedSellerPriceGridListingList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sellerGridSearchCreate(sellerPriceGridSearchRequest, aaSource, ordering, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The view behaves in the same manner as the search listing but it returns only those who the user has bookmarked
         * @summary Returns the prices the user has bookmarked
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {Array<'-delivery_date' | '-name' | '-price' | '-updated' | 'delivery_date' | 'name' | 'price' | 'updated'>} [ordering] Ordering  * &#x60;updated&#x60; - Updated * &#x60;-updated&#x60; - Updated (descending) * &#x60;name&#x60; - Name * &#x60;-name&#x60; - Name (descending) * &#x60;price&#x60; - Price * &#x60;-price&#x60; - Price (descending) * &#x60;delivery_date&#x60; - Delivery date * &#x60;-delivery_date&#x60; - Delivery date (descending)
         * @param {number} [pageSize] Number of results to return per page.
         * @param {SellerPriceGridSearchOrderingRequest} [sellerPriceGridSearchOrderingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sellerGridSearchMyPricesCreate(aaSource?: string, ordering?: Array<'-delivery_date' | '-name' | '-price' | '-updated' | 'delivery_date' | 'name' | 'price' | 'updated'>, pageSize?: number, sellerPriceGridSearchOrderingRequest?: SellerPriceGridSearchOrderingRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedSellerPriceGridListingList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sellerGridSearchMyPricesCreate(aaSource, ordering, pageSize, sellerPriceGridSearchOrderingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Get the details of a price grid
         * @param {string} priceGridId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sellerGridSearchRetrieve(priceGridId: string, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SellerPriceGridListing>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sellerGridSearchRetrieve(priceGridId, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Increments the view count on the Price Grid from the app
         * @param {string} priceGridId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sellerGridSearchViewPriceGridRetrieve(priceGridId: string, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SellerPriceGridListing>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sellerGridSearchViewPriceGridRetrieve(priceGridId, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Increments the view count on the Price Grid from the app
         * @param {string} priceGridId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sellerGridViewPriceGridRetrieve(priceGridId: string, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SellerPriceGridListing>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sellerGridViewPriceGridRetrieve(priceGridId, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SellerPriceGridsSearchApi - factory interface
 * @export
 */
export const SellerPriceGridsSearchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SellerPriceGridsSearchApiFp(configuration)
    return {
        /**
         * Returns a list of all the status=ACTIVE Price Grids which match the given search criteria  It is also filtered on the visibility of the grid.If it is is PUBLIC then everyone can see it.If it is CONTACTS only then only those who are approved contacts of the Buyer organisation can see it.  ## Filters See parameters below  ## Ordering The following fields can be used for ordering, it can be done by passing in the ordering query string param. eg. `?ordering=updated` To reverse, simply place a hyphen in front. eg. `?ordering=-updated`  - updated: The last time the grid was updated (default: -updated = latest to oldest) - name: The buyer organisations name - price: The pricing range, default is highest first so it goes against the price_range_max field, when     -price then it goes via the min field     -When searching via this then those that are set to PRICE_RANGE will be at the top of the listing, even in both     -orders `price` and `-price`. Putting those that are POA and MARKET_RATE at the bottom.  The results by default are returned with the latest updated first.         
         * @summary Perform a search on the accessible price grids.
         * @param {SellerPriceGridSearchRequest} sellerPriceGridSearchRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {Array<'-delivery_date' | '-name' | '-price' | '-updated' | 'delivery_date' | 'name' | 'price' | 'updated'>} [ordering] Ordering  * &#x60;updated&#x60; - Updated * &#x60;-updated&#x60; - Updated (descending) * &#x60;name&#x60; - Name * &#x60;-name&#x60; - Name (descending) * &#x60;price&#x60; - Price * &#x60;-price&#x60; - Price (descending) * &#x60;delivery_date&#x60; - Delivery date * &#x60;-delivery_date&#x60; - Delivery date (descending)
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerGridCreate(sellerPriceGridSearchRequest: SellerPriceGridSearchRequest, aaSource?: string, ordering?: Array<'-delivery_date' | '-name' | '-price' | '-updated' | 'delivery_date' | 'name' | 'price' | 'updated'>, pageSize?: number, options?: any): AxiosPromise<PaginatedSellerPriceGridListingList> {
            return localVarFp.sellerGridCreate(sellerPriceGridSearchRequest, aaSource, ordering, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Get the details of a price grid
         * @param {string} priceGridId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerGridRetrieve(priceGridId: string, aaSource?: string, options?: any): AxiosPromise<SellerPriceGridListing> {
            return localVarFp.sellerGridRetrieve(priceGridId, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of all the status=ACTIVE Price Grids which match the given search criteria  It is also filtered on the visibility of the grid.If it is is PUBLIC then everyone can see it.If it is CONTACTS only then only those who are approved contacts of the Buyer organisation can see it.  ## Filters See parameters below  ## Ordering The following fields can be used for ordering, it can be done by passing in the ordering query string param. eg. `?ordering=updated` To reverse, simply place a hyphen in front. eg. `?ordering=-updated`  - updated: The last time the grid was updated (default: -updated = latest to oldest) - name: The buyer organisations name - price: The pricing range, default is highest first so it goes against the price_range_max field, when     -price then it goes via the min field     -When searching via this then those that are set to PRICE_RANGE will be at the top of the listing, even in both     -orders `price` and `-price`. Putting those that are POA and MARKET_RATE at the bottom.  The results by default are returned with the latest updated first.         
         * @summary Perform a search on the accessible price grids.
         * @param {SellerPriceGridSearchRequest} sellerPriceGridSearchRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {Array<'-delivery_date' | '-name' | '-price' | '-updated' | 'delivery_date' | 'name' | 'price' | 'updated'>} [ordering] Ordering  * &#x60;updated&#x60; - Updated * &#x60;-updated&#x60; - Updated (descending) * &#x60;name&#x60; - Name * &#x60;-name&#x60; - Name (descending) * &#x60;price&#x60; - Price * &#x60;-price&#x60; - Price (descending) * &#x60;delivery_date&#x60; - Delivery date * &#x60;-delivery_date&#x60; - Delivery date (descending)
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerGridSearchCreate(sellerPriceGridSearchRequest: SellerPriceGridSearchRequest, aaSource?: string, ordering?: Array<'-delivery_date' | '-name' | '-price' | '-updated' | 'delivery_date' | 'name' | 'price' | 'updated'>, pageSize?: number, options?: any): AxiosPromise<PaginatedSellerPriceGridListingList> {
            return localVarFp.sellerGridSearchCreate(sellerPriceGridSearchRequest, aaSource, ordering, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * The view behaves in the same manner as the search listing but it returns only those who the user has bookmarked
         * @summary Returns the prices the user has bookmarked
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {Array<'-delivery_date' | '-name' | '-price' | '-updated' | 'delivery_date' | 'name' | 'price' | 'updated'>} [ordering] Ordering  * &#x60;updated&#x60; - Updated * &#x60;-updated&#x60; - Updated (descending) * &#x60;name&#x60; - Name * &#x60;-name&#x60; - Name (descending) * &#x60;price&#x60; - Price * &#x60;-price&#x60; - Price (descending) * &#x60;delivery_date&#x60; - Delivery date * &#x60;-delivery_date&#x60; - Delivery date (descending)
         * @param {number} [pageSize] Number of results to return per page.
         * @param {SellerPriceGridSearchOrderingRequest} [sellerPriceGridSearchOrderingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerGridSearchMyPricesCreate(aaSource?: string, ordering?: Array<'-delivery_date' | '-name' | '-price' | '-updated' | 'delivery_date' | 'name' | 'price' | 'updated'>, pageSize?: number, sellerPriceGridSearchOrderingRequest?: SellerPriceGridSearchOrderingRequest, options?: any): AxiosPromise<PaginatedSellerPriceGridListingList> {
            return localVarFp.sellerGridSearchMyPricesCreate(aaSource, ordering, pageSize, sellerPriceGridSearchOrderingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Get the details of a price grid
         * @param {string} priceGridId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerGridSearchRetrieve(priceGridId: string, aaSource?: string, options?: any): AxiosPromise<SellerPriceGridListing> {
            return localVarFp.sellerGridSearchRetrieve(priceGridId, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Increments the view count on the Price Grid from the app
         * @param {string} priceGridId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerGridSearchViewPriceGridRetrieve(priceGridId: string, aaSource?: string, options?: any): AxiosPromise<SellerPriceGridListing> {
            return localVarFp.sellerGridSearchViewPriceGridRetrieve(priceGridId, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Increments the view count on the Price Grid from the app
         * @param {string} priceGridId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerGridViewPriceGridRetrieve(priceGridId: string, aaSource?: string, options?: any): AxiosPromise<SellerPriceGridListing> {
            return localVarFp.sellerGridViewPriceGridRetrieve(priceGridId, aaSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for sellerGridCreate operation in SellerPriceGridsSearchApi.
 * @export
 * @interface SellerPriceGridsSearchApiSellerGridCreateRequest
 */
export interface SellerPriceGridsSearchApiSellerGridCreateRequest {
    /**
     * 
     * @type {SellerPriceGridSearchRequest}
     * @memberof SellerPriceGridsSearchApiSellerGridCreate
     */
    readonly sellerPriceGridSearchRequest: SellerPriceGridSearchRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof SellerPriceGridsSearchApiSellerGridCreate
     */
    readonly aaSource?: string

    /**
     * Ordering  * &#x60;updated&#x60; - Updated * &#x60;-updated&#x60; - Updated (descending) * &#x60;name&#x60; - Name * &#x60;-name&#x60; - Name (descending) * &#x60;price&#x60; - Price * &#x60;-price&#x60; - Price (descending) * &#x60;delivery_date&#x60; - Delivery date * &#x60;-delivery_date&#x60; - Delivery date (descending)
     * @type {Array<'-delivery_date' | '-name' | '-price' | '-updated' | 'delivery_date' | 'name' | 'price' | 'updated'>}
     * @memberof SellerPriceGridsSearchApiSellerGridCreate
     */
    readonly ordering?: Array<'-delivery_date' | '-name' | '-price' | '-updated' | 'delivery_date' | 'name' | 'price' | 'updated'>

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof SellerPriceGridsSearchApiSellerGridCreate
     */
    readonly pageSize?: number
}

/**
 * Request parameters for sellerGridRetrieve operation in SellerPriceGridsSearchApi.
 * @export
 * @interface SellerPriceGridsSearchApiSellerGridRetrieveRequest
 */
export interface SellerPriceGridsSearchApiSellerGridRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof SellerPriceGridsSearchApiSellerGridRetrieve
     */
    readonly priceGridId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof SellerPriceGridsSearchApiSellerGridRetrieve
     */
    readonly aaSource?: string
}

/**
 * Request parameters for sellerGridSearchCreate operation in SellerPriceGridsSearchApi.
 * @export
 * @interface SellerPriceGridsSearchApiSellerGridSearchCreateRequest
 */
export interface SellerPriceGridsSearchApiSellerGridSearchCreateRequest {
    /**
     * 
     * @type {SellerPriceGridSearchRequest}
     * @memberof SellerPriceGridsSearchApiSellerGridSearchCreate
     */
    readonly sellerPriceGridSearchRequest: SellerPriceGridSearchRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof SellerPriceGridsSearchApiSellerGridSearchCreate
     */
    readonly aaSource?: string

    /**
     * Ordering  * &#x60;updated&#x60; - Updated * &#x60;-updated&#x60; - Updated (descending) * &#x60;name&#x60; - Name * &#x60;-name&#x60; - Name (descending) * &#x60;price&#x60; - Price * &#x60;-price&#x60; - Price (descending) * &#x60;delivery_date&#x60; - Delivery date * &#x60;-delivery_date&#x60; - Delivery date (descending)
     * @type {Array<'-delivery_date' | '-name' | '-price' | '-updated' | 'delivery_date' | 'name' | 'price' | 'updated'>}
     * @memberof SellerPriceGridsSearchApiSellerGridSearchCreate
     */
    readonly ordering?: Array<'-delivery_date' | '-name' | '-price' | '-updated' | 'delivery_date' | 'name' | 'price' | 'updated'>

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof SellerPriceGridsSearchApiSellerGridSearchCreate
     */
    readonly pageSize?: number
}

/**
 * Request parameters for sellerGridSearchMyPricesCreate operation in SellerPriceGridsSearchApi.
 * @export
 * @interface SellerPriceGridsSearchApiSellerGridSearchMyPricesCreateRequest
 */
export interface SellerPriceGridsSearchApiSellerGridSearchMyPricesCreateRequest {
    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof SellerPriceGridsSearchApiSellerGridSearchMyPricesCreate
     */
    readonly aaSource?: string

    /**
     * Ordering  * &#x60;updated&#x60; - Updated * &#x60;-updated&#x60; - Updated (descending) * &#x60;name&#x60; - Name * &#x60;-name&#x60; - Name (descending) * &#x60;price&#x60; - Price * &#x60;-price&#x60; - Price (descending) * &#x60;delivery_date&#x60; - Delivery date * &#x60;-delivery_date&#x60; - Delivery date (descending)
     * @type {Array<'-delivery_date' | '-name' | '-price' | '-updated' | 'delivery_date' | 'name' | 'price' | 'updated'>}
     * @memberof SellerPriceGridsSearchApiSellerGridSearchMyPricesCreate
     */
    readonly ordering?: Array<'-delivery_date' | '-name' | '-price' | '-updated' | 'delivery_date' | 'name' | 'price' | 'updated'>

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof SellerPriceGridsSearchApiSellerGridSearchMyPricesCreate
     */
    readonly pageSize?: number

    /**
     * 
     * @type {SellerPriceGridSearchOrderingRequest}
     * @memberof SellerPriceGridsSearchApiSellerGridSearchMyPricesCreate
     */
    readonly sellerPriceGridSearchOrderingRequest?: SellerPriceGridSearchOrderingRequest
}

/**
 * Request parameters for sellerGridSearchRetrieve operation in SellerPriceGridsSearchApi.
 * @export
 * @interface SellerPriceGridsSearchApiSellerGridSearchRetrieveRequest
 */
export interface SellerPriceGridsSearchApiSellerGridSearchRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof SellerPriceGridsSearchApiSellerGridSearchRetrieve
     */
    readonly priceGridId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof SellerPriceGridsSearchApiSellerGridSearchRetrieve
     */
    readonly aaSource?: string
}

/**
 * Request parameters for sellerGridSearchViewPriceGridRetrieve operation in SellerPriceGridsSearchApi.
 * @export
 * @interface SellerPriceGridsSearchApiSellerGridSearchViewPriceGridRetrieveRequest
 */
export interface SellerPriceGridsSearchApiSellerGridSearchViewPriceGridRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof SellerPriceGridsSearchApiSellerGridSearchViewPriceGridRetrieve
     */
    readonly priceGridId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof SellerPriceGridsSearchApiSellerGridSearchViewPriceGridRetrieve
     */
    readonly aaSource?: string
}

/**
 * Request parameters for sellerGridViewPriceGridRetrieve operation in SellerPriceGridsSearchApi.
 * @export
 * @interface SellerPriceGridsSearchApiSellerGridViewPriceGridRetrieveRequest
 */
export interface SellerPriceGridsSearchApiSellerGridViewPriceGridRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof SellerPriceGridsSearchApiSellerGridViewPriceGridRetrieve
     */
    readonly priceGridId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof SellerPriceGridsSearchApiSellerGridViewPriceGridRetrieve
     */
    readonly aaSource?: string
}

/**
 * SellerPriceGridsSearchApi - object-oriented interface
 * @export
 * @class SellerPriceGridsSearchApi
 * @extends {BaseAPI}
 */
export class SellerPriceGridsSearchApi extends BaseAPI {
    /**
     * Returns a list of all the status=ACTIVE Price Grids which match the given search criteria  It is also filtered on the visibility of the grid.If it is is PUBLIC then everyone can see it.If it is CONTACTS only then only those who are approved contacts of the Buyer organisation can see it.  ## Filters See parameters below  ## Ordering The following fields can be used for ordering, it can be done by passing in the ordering query string param. eg. `?ordering=updated` To reverse, simply place a hyphen in front. eg. `?ordering=-updated`  - updated: The last time the grid was updated (default: -updated = latest to oldest) - name: The buyer organisations name - price: The pricing range, default is highest first so it goes against the price_range_max field, when     -price then it goes via the min field     -When searching via this then those that are set to PRICE_RANGE will be at the top of the listing, even in both     -orders `price` and `-price`. Putting those that are POA and MARKET_RATE at the bottom.  The results by default are returned with the latest updated first.         
     * @summary Perform a search on the accessible price grids.
     * @param {SellerPriceGridsSearchApiSellerGridCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerPriceGridsSearchApi
     */
    public sellerGridCreate(requestParameters: SellerPriceGridsSearchApiSellerGridCreateRequest, options?: any) {
        return SellerPriceGridsSearchApiFp(this.configuration).sellerGridCreate(requestParameters.sellerPriceGridSearchRequest, requestParameters.aaSource, requestParameters.ordering, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allow external IDs to be used for generic API views.
     * @summary Get the details of a price grid
     * @param {SellerPriceGridsSearchApiSellerGridRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerPriceGridsSearchApi
     */
    public sellerGridRetrieve(requestParameters: SellerPriceGridsSearchApiSellerGridRetrieveRequest, options?: any) {
        return SellerPriceGridsSearchApiFp(this.configuration).sellerGridRetrieve(requestParameters.priceGridId, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list of all the status=ACTIVE Price Grids which match the given search criteria  It is also filtered on the visibility of the grid.If it is is PUBLIC then everyone can see it.If it is CONTACTS only then only those who are approved contacts of the Buyer organisation can see it.  ## Filters See parameters below  ## Ordering The following fields can be used for ordering, it can be done by passing in the ordering query string param. eg. `?ordering=updated` To reverse, simply place a hyphen in front. eg. `?ordering=-updated`  - updated: The last time the grid was updated (default: -updated = latest to oldest) - name: The buyer organisations name - price: The pricing range, default is highest first so it goes against the price_range_max field, when     -price then it goes via the min field     -When searching via this then those that are set to PRICE_RANGE will be at the top of the listing, even in both     -orders `price` and `-price`. Putting those that are POA and MARKET_RATE at the bottom.  The results by default are returned with the latest updated first.         
     * @summary Perform a search on the accessible price grids.
     * @param {SellerPriceGridsSearchApiSellerGridSearchCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerPriceGridsSearchApi
     */
    public sellerGridSearchCreate(requestParameters: SellerPriceGridsSearchApiSellerGridSearchCreateRequest, options?: any) {
        return SellerPriceGridsSearchApiFp(this.configuration).sellerGridSearchCreate(requestParameters.sellerPriceGridSearchRequest, requestParameters.aaSource, requestParameters.ordering, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The view behaves in the same manner as the search listing but it returns only those who the user has bookmarked
     * @summary Returns the prices the user has bookmarked
     * @param {SellerPriceGridsSearchApiSellerGridSearchMyPricesCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerPriceGridsSearchApi
     */
    public sellerGridSearchMyPricesCreate(requestParameters: SellerPriceGridsSearchApiSellerGridSearchMyPricesCreateRequest = {}, options?: any) {
        return SellerPriceGridsSearchApiFp(this.configuration).sellerGridSearchMyPricesCreate(requestParameters.aaSource, requestParameters.ordering, requestParameters.pageSize, requestParameters.sellerPriceGridSearchOrderingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allow external IDs to be used for generic API views.
     * @summary Get the details of a price grid
     * @param {SellerPriceGridsSearchApiSellerGridSearchRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerPriceGridsSearchApi
     */
    public sellerGridSearchRetrieve(requestParameters: SellerPriceGridsSearchApiSellerGridSearchRetrieveRequest, options?: any) {
        return SellerPriceGridsSearchApiFp(this.configuration).sellerGridSearchRetrieve(requestParameters.priceGridId, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allow external IDs to be used for generic API views.
     * @summary Increments the view count on the Price Grid from the app
     * @param {SellerPriceGridsSearchApiSellerGridSearchViewPriceGridRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerPriceGridsSearchApi
     */
    public sellerGridSearchViewPriceGridRetrieve(requestParameters: SellerPriceGridsSearchApiSellerGridSearchViewPriceGridRetrieveRequest, options?: any) {
        return SellerPriceGridsSearchApiFp(this.configuration).sellerGridSearchViewPriceGridRetrieve(requestParameters.priceGridId, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allow external IDs to be used for generic API views.
     * @summary Increments the view count on the Price Grid from the app
     * @param {SellerPriceGridsSearchApiSellerGridViewPriceGridRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerPriceGridsSearchApi
     */
    public sellerGridViewPriceGridRetrieve(requestParameters: SellerPriceGridsSearchApiSellerGridViewPriceGridRetrieveRequest, options?: any) {
        return SellerPriceGridsSearchApiFp(this.configuration).sellerGridViewPriceGridRetrieve(requestParameters.priceGridId, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }
}
